export const DEBUG_COMPONENT_NAME_INDEX: Record<string, string> = {
  AdminFooter: "Admin footer",
  AdminHeader: "Admin header",
  AdminPuzzlesScreen: "Puzzle admin",
  AdminSnippetsScreen: "Snippet admin",
  AdminSnippetsWorkbenchScreen: "Snippet workbench",
  AppTheme: "Theme",
  AssignmentsControls: "Assignment controls",
  AssignmentsDialogs: "Assignment dialogs",
  AssignmentsMenus: "Assignment menus",
  AssignmentsScreen: "Assignments",
  AssignmentsSettingsPopovers: "Assignment settings",
  AssignmentsTableScreen: "Assignment table",
  AssignmentsTopBar: "Assignment top bar",
  Block: "Code block",
  BrowserCheck: "Browser check",
  BrowserSizeAlert: "Browser size alert",
  CodeContent: "Code content",
  ColorModeIconDropdown: "Theme menu",
  ColorModeSelect: "Theme select",
  ColorModeToggle: "Theme toggle",
  CourseChooserPage: "Course chooser",
  CourseScreen: "Course admin",
  CoursesScreen: "Courses admin",
  dataDisplay: "Data display theme",
  DescriptionWithCodeBlocks: "Description",
  DebugModeToggle: "Debugging mode selector",
  EnrollmentsScreen: "Enrollments",
  EventReplayLinksScreen: "Event replay links",
  AssignmentTraceClient: "Assignment event trace",
  feedback: "Feedback theme",
  FileTreePanel: "File tree",
  FooterShell: "Footer",
  GradingScreen: "Grading",
  HomePage: "Home",
  inputs: "Input theme",
  InteractionLogger: "Interaction logger",
  layout: "Layout",
  LegacyAssignmentsTableScreen: "Legacy assignments",
  Loading: "Loading",
  Login: "Login",
  Logo: "Logo",
  LogsAggregateScreen: "Log aggregates",
  LogsScreen: "Logs",
  MenuButton: "Menu button",
  navigation: "Navigation theme",
  OptionsMenu: "Options menu",
  page: "Page",
  PlotDialogShell: "Plot dialog",
  PlotInlineShell: "Plot",
  ProgramsScreen: "Programs",
  Providers: "Providers",
  PuzzleHeader: "Puzzle header",
  PuzzleInstance: "Puzzle",
  PuzzleInstanceClient: "Puzzle client",
  PuzzleSelector: "Puzzle selector",
  PuzzleTextSizeProvider: "Text size provider",
  PuzzleTimerFooter: "Puzzle footer",
  PuzzleUnlockQrDialog: "Unlock QR",
  PuzzlesScreen: "Puzzles",
  RawLogsScreen: "Raw logs",
  ReflectionClient: "Reflect",
  ReflectionsScreen: "Reflections",
  ReleasePlanScreen: "Release plan",
  ReviewInstructionsPanel: "Review instructions",
  ReviewSortableListsClientImpl: "Review sorter",
  SnippetsScreen: "Snippets",
  SortableItem: "Sortable item",
  StaffActivationScannerDialog: "Scanner dialog",
  StandardHelperTooltipContent: "Help tooltip",
  SyntaxHighlightThemeProvider: "Syntax theme",
  SyntaxHighlightThemeSelect: "Syntax theme select",
  TasksScreen: "Tasks",
  TwoColumnDnD: "Two-column sorter",
  useLegacyAssignmentsBodyRenderer: "Legacy body renderer",
  useLegacyAssignmentsHeaderRenderer: "Legacy header renderer",
  UsersScreen: "Users",
};

const NAME_SUFFIXES = [
  "Screen",
  "Page",
  "Layout",
  "Dialog",
  "Panel",
  "Provider",
  "Client",
  "Header",
  "Footer",
  "Menu",
  "Button",
  "Table",
];

function splitPascalCase(name: string): string[] {
  return name
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0);
}

export function getShortComponentLabel(name: string): string {
  const indexed = DEBUG_COMPONENT_NAME_INDEX[name];
  if (indexed) {
    return indexed;
  }

  const trimmed = name.trim();
  if (/^[A-Za-z]$/.test(trimmed)) {
    return "Element";
  }

  let base = name.trim();
  for (const suffix of NAME_SUFFIXES) {
    if (base.endsWith(suffix) && base.length > suffix.length) {
      base = base.slice(0, -suffix.length);
      break;
    }
  }

  const words = splitPascalCase(base);
  if (words.length === 0) {
    return name;
  }

  const normalized = words.slice(0, 3).join(" ");
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
}
